import { css } from '@emotion/core'
import theme from 'Theme'
import { mediumUp } from 'Utils'
const {
  mixins,
  colors,
  typography,
  spacing,
  components: { productCard }
} = theme

export const plain = () => css`
  position: relative;
  max-width: 300px;
  background-color: ${colors.white};
  border: 1px solid ${colors.borderGreyLight};

  &:active {
    background-color: ${colors.white};
    border: 1px solid ${colors.borderGreyLight};
  }

  @media ${mediumUp} {
    max-width: none;
    &:hover {
      ${mixins.cardBoxShadow(theme)}
    }
  }

  .image-link {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    height: 240px;
    background-color: ${colors.white};

    @media ${mediumUp} {
      height: 390px;
    }

    img {
      display: block;
      flex-shrink: 0;
      object-fit: contain;
      max-height: 220px;
      @media ${mediumUp} {
        max-height: 370px;
      }
    }
  }

  .footer {
    padding: 7px 16px 16px 16px;
    transition: all 0.2s ease;

    .product-price {
      span {
        margin-right: 16px;
      }
    }
    .product-brand {
      text-transform: uppercase;
      word-break: break-word;
    }

    .price {
      font-weight: ${typography.headings.fontWeight};
    }

    h4 {
      margin-bottom: ${spacing.base_1}px;
      font-weight: ${productCard.titleWeight};
    }
  }

  .discount {
    text-decoration: line-through;
    color: ${productCard.discountColor};
  }

  /* style the comparand product-card here by overriding the cards skin */
  &.comparand {
    background-color: ${colors.primary};
    color: ${colors.complementary.primary};
    transition: 0s;

    .footer {
      padding: 13px;
      background-color: ${colors.primary};
      border-bottom: none;
      transition: 0s;
      a {
        padding: 16px;
      }

      h4,
      .price,
      .original-price {
        color: ${colors.complementary.primary};
        transition: color 200ms ease-out;
      }
    }

    .image-link {
      overflow: hidden;
      border: 3px solid ${colors.primary};
    }

    &:hover {
      ${mixins.cardBoxShadow(theme)}
      background-color: ${colors.darkGrey};
      .image-link {
        border-color: ${colors.darkGrey};
      }
      .footer {
        background-color: ${colors.darkGrey};
      }
    }

    .favourite-button svg[name="favorite"] {
      fill: ${colors.complementary.primary};
    }
  }
  

  .favourite-button {
    position: absolute;
    bottom: 0;
    right: 0;
    svg[name='favorite_border'] {
      fill: ${colors.borderGrey};
    }
  }
`

export default plain
